import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Card, Row, Col, Table, Popover,ConfigProvider,theme} from 'antd';
import { QuestionCircleOutlined ,DownloadOutlined} from '@ant-design/icons';
import help from '../../config/help.json';
import {CSVLink} from 'react-csv';


import './analytics.css';


var cc_data;

class AdImpressionAppCard extends Component {
	constructor(props) {
		super(props);
		this.state = {
		 }
	}

	async componentDidUpdate(prevProps) {
	}

	render() {
		const { defaultAlgorithm, darkAlgorithm } = theme;
		const {  userTheme,opensearchAdImpressionByAppList } = this.props;

		cc_data = opensearchAdImpressionByAppList || [];
		
		// takes an array of objects and the name of a property of these objects
		function getGroupByKeys(array, index){
			let temparr = [];
			array.forEach(d => {
				if(d && d[index]){
					if(!temparr.some(f => f.text === d[index])){
						temparr.push({text:d[index], value:d[index]})
					}
				}
			})
			return temparr;
		}

		// format table data;
		let dataset = [];
		let key =0;
		cc_data.forEach(d => {
			if(d.appVersion && d.appVersion.buckets){
				d.appVersion.buckets.forEach(c => {
					dataset.push({appName: d.key, appVersion: c.key, doc_count: c.doc_count, key:key});
					key+=1;
				})
			}
		})
		dataset = dataset.sort((a, b) => b.doc_count - a.doc_count);
		dataset = dataset.slice(0, 10); // only need the first 10 records.
		const columns = [
			{
			  title: 'APP Name',
			  dataIndex: 'appName',
			  filters: getGroupByKeys(dataset, "appName"),
			  onFilter: (value, record) => record.appName.indexOf(value) === 0,
			  sorter: (a, b) => a.appName.localeCompare(b.appName),
			  
			},
			{
				title: 'APP Version',
				dataIndex: 'appVersion',
				filters: getGroupByKeys(dataset, "appVersion"),
				onFilter: (value, record) => record.appVersion.indexOf(value) === 0,
				sorter: (a, b) => a.appVersion.localeCompare(b.appVersion),
				
			},
			{
			  title: 'Count',
			  dataIndex: 'doc_count',
			  sorter: (a, b) => a.doc_count - b.doc_count,
				defaultSortOrder: 'descend',
			  
			}
		  ];

		return (
			<ConfigProvider theme={{
				algorithm: userTheme === 'dark' ?darkAlgorithm : defaultAlgorithm,
			  }}>
      <Card className="analyticCard analyticActiveUsersCard">
				<h3 className="title">{`Ads impression by App Name and Version  `}
					<Popover placement="topLeft"
						overlayStyle={{width:'300px'}}
						content= {help.find(d=> d.name ==='AdImpressionAppCard').en}
						trigger="click"><QuestionCircleOutlined />
					</Popover>
					<CSVLink data={dataset} target="_blank" filename={"Ads impression by App Name and Version.csv"}>
						<DownloadOutlined />
					</CSVLink>
				</h3>
				<Row>
				 <Col span={24}>
				 <Table style={{ width: '100%' }} dataSource={dataset} columns={columns} pagination={{pageSize:5}}/>
					{/* <ReactECharts style={{ height: 320, width: '100%' }} theme={userTheme} option={option} notMerge={true} showLoading={loading} loadingOption={{color:"#74add1"}} /> */}
				</Col>
 				</Row>
     </Card>
	 </ConfigProvider>
		);
	}


}

const mapStateToProps = state => ({
	router: state.router,
	userTheme: state.user.userTheme,
	selectedOrganization: state.user.selectedOrganization,
	opensearchAdImpressionByAppList: state.advertisement.opensearchAdImpressionByAppList
});

const mapDispatchToProps = dispatch =>
	bindActionCreators(
		{
		},
		dispatch
	);

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(AdImpressionAppCard));
